if (!customElements.get('the-fold-accordion')) {
  customElements.define('the-fold-accordion', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('click', (event) => {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        const item = summary.parentElement;
        this.setExpanded(item, item.dataset.expanded !== 'true');
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('details');
        if (item) this.setExpanded(item, true);
      }, { signal });
      for (const item of this.querySelectorAll('details')) {
        item.dataset.expanded = String(item.open);
        item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      for (const item of this.querySelectorAll('details')) item.foldAnimation?.finish();
    }

    setExpanded(item, expanded) {
      if (expanded) {
        for (const sibling of item.parentElement.children) {
          if (sibling !== item && sibling.dataset.expanded === 'true') this.setExpanded(sibling, false);
        }
      }
      const start = item.getBoundingClientRect().height;
      if (item.foldAnimation) {
        item.foldAnimation.onfinish = null;
        item.foldAnimation.cancel();
      }
      item.dataset.expanded = String(expanded);
      item.querySelector('summary').setAttribute('aria-expanded', String(expanded));
      item.open = expanded;
      const end = item.getBoundingClientRect().height;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // Keep the answer rendered until its closing animation finishes.
      item.open = true;
      item.foldAnimation = item.animate({ height: [`${start}px`, `${end}px`] }, {
        duration: 125,
        easing: 'ease-in-out'
      });
      item.foldAnimation.onfinish = () => {
        item.open = expanded;
        item.foldAnimation = null;
      };
    }
  });
}
